import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';

const Partners = () => {
  const partners = [
    {
      name: "Partenaire 1",
      logo: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739390349/1739389621276_nsnxuq.png"
    },
    {
      name: "Partenaire 2",
      logo: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739390348/1739389619785_x7y1no.png"
    },
    {
      name: "NeoFoods",
      logo: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739390348/neofoods_v94wbi.png"
    },
    {
      name: "Partenaire 5",
      logo: "https://res.cloudinary.com/dansvy9a5/image/upload/v1739390763/1739390718590_wha6lw.png"
    }
  ];

  // Double the partners array for continuous scrolling
  const scrollPartners = [...partners, ...partners];
  const controls = useAnimation();

  useEffect(() => {
    const startScrollAnimation = async () => {
      await controls.start({
        x: [0, -50 * partners.length], // Scroll distance based on number of partners
        transition: {
          duration: 20,
          ease: "linear",
          repeat: Infinity,
        }
      });
    };

    startScrollAnimation();
  }, [controls, partners.length]);

  return (
    <div className="section-transition py-32 border-t border-b border-[#41392e]/10">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          className="flex space-x-32"
          animate={controls}
          style={{ width: `${200 * scrollPartners.length}px` }}
        >
          {scrollPartners.map((partner, index) => (
            <motion.div
              key={`${partner.name}-${index}`}
              className="flex items-center justify-center group relative flex-shrink-0"
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
            >
              <div className="relative">
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className="h-32 opacity-50 transition-all duration-500 group-hover:opacity-100"
                />
                <div className="absolute -inset-6 border border-[#41392e] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Partners;